import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import song from "../assets/audio/pattista-promo-song.mp3";

let audio = null;

function getAudio() {
  if (!audio) {
    audio = new Audio(song);
    audio.volume = 0.5;
    audio.preload = "auto";
    if (typeof window !== "undefined") window.__pattistaSong = audio;
  }
  return audio;
}

export default function PromoSong() {
  const [state, setState] = useState({ playing: false, muted: false });
  const startedRef = useRef(false);

  useEffect(() => {
    const a = getAudio();
    const onEnded = () => setState((s) => ({ ...s, playing: false }));

    const start = () => {
      if (startedRef.current) return;
      startedRef.current = true;
      a.play()
        .then(() => setState({ playing: true, muted: a.muted }))
        .catch(() => {
          startedRef.current = false;
        });
    };

    const onGesture = () => {
      start();
      if (startedRef.current) {
        window.removeEventListener("pointerdown", onGesture);
        window.removeEventListener("keydown", onGesture);
      }
    };

    a.addEventListener("ended", onEnded);
    start();
    window.addEventListener("pointerdown", onGesture);
    window.addEventListener("keydown", onGesture);

    return () => {
      a.removeEventListener("ended", onEnded);
      window.removeEventListener("pointerdown", onGesture);
      window.removeEventListener("keydown", onGesture);
    };
  }, []);

  const onToggle = () => {
    const a = getAudio();
    if (!startedRef.current || a.ended) {
      a.currentTime = 0;
      a.muted = false;
      setState({ playing: true, muted: false });
      startedRef.current = true;
      a.play().catch(() => setState({ playing: false, muted: false }));
      return;
    }
    const next = !a.muted;
    a.muted = next;
    setState({ playing: !a.paused, muted: next });
  };

  const showOn = state.playing && !state.muted;

  return (
    <button
      type="button"
      data-testid="music-toggle-button"
      onClick={onToggle}
      aria-label={showOn ? "Mute promo song" : "Play promo song"}
      title={showOn ? "Sound on — Pattista promo song" : "Sound off"}
      className="fixed bottom-5 left-5 z-[110] inline-flex h-12 w-12 items-center justify-center rounded-full border-[3px] border-jet bg-amber text-jet shadow-hard-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-hard"
    >
      {showOn ? (
        <Volume2 className="h-5 w-5" aria-hidden="true" />
      ) : (
        <VolumeX className="h-5 w-5" aria-hidden="true" />
      )}
      {showOn && (
        <span className="absolute -right-1 -top-1 flex h-3 w-3" aria-hidden="true">
          <span className="absolute h-3 w-3 animate-ping rounded-full bg-flame opacity-75" />
          <span className="h-3 w-3 rounded-full border-2 border-jet bg-flame" />
        </span>
      )}
    </button>
  );
}
